import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Personal Settings store — Story 92.2 Task 4.
 *
 * Open/close flag for the Personal Settings modal. The modal itself is built
 * in Story 92.5; 92.2 only flips the flag.
 */
interface PersonalSettingsStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const usePersonalSettingsStore = create<PersonalSettingsStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      open: () => set({ isOpen: true }, false, 'personalSettings/open'),
      close: () => set({ isOpen: false }, false, 'personalSettings/close'),
    }),
    { name: 'personalSettingsStore' }
  )
);
